(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');

    // directive for agenda-day
    module.directive('agendaPerPeriod', ['$timeout','HelperService', 'AgendaBroadcast', function ($timeout, HelperService, AgendaBroadcast) {
        var directive = {
            link: link,
            restrict: 'A',
            template: '<ng-include src="::templateUrl" />',
            controller: 'AgendaPerPeriodController',
            controllerAs: 'vm',
            scope: {
                sharedAgenda: '=', // the agenda to show
                period: '@'         // period -> day or week
            },
            bindToController: true
        };
        return directive;

        function link(scope, element) {
            // set template url based on period
            scope.templateUrl = '/app/agenda/templates/agenda-per-period-' + scope.vm.period + '.template.html';
            
            //wait for the DOM to load
            $timeout(function () {
                //Get the elements with id ='text'
                const elements = document.querySelectorAll('#usernameAndIcons');
                //Get the max width
                let maxWidth = Math.max(...Array.from(elements).map(header => header.offsetWidth));
                //set all the elements width to the max width by default
                elements.forEach(element => {
                    element.style.width = `${maxWidth}px`;
                });
            });
                    

            // block mode
            // var blocking = true;               

            // // block at startup
            // HelperService.block(element);
            //
            // // listen
            // var unbinder = scope.$on(AgendaBroadcast.BlockUnblock, function (event, id) {
            //     if (scope.vm.sharedAgenda.id !== id) { return; }
            //
            //     // block or unblock
            //     if (blocking) {
            //         HelperService.unblock(element);
            //         blocking = false;
            //     }
            //     else {
            //         HelperService.block(element);
            //         blocking = true;
            //     } // else
            // });

            // on destroy
            scope.$on('$destroy', function () {
                // unbinder();
                // unbinder = null;
                scope.templateUrl = null;
                // blocking = null;
            });
        }

    }]);

})();